import ajax from "plugins/AjaxService"
import { Crop } from "types/Crop"
import humps from "humps"
import { CropRecipe } from "types/CropRecipe"



// url builder
const urlBuilder = (id?: number) => `crops_recipes${id ? `/${id}` : ""}`

/**
 * INDEX
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-60335
 */
const index = (): Promise<{ data: CropRecipe[] }> => ajax.get(urlBuilder())

/**
 * GET
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-28915
 */
async function get(id: number): Promise<{ data: CropRecipe }> {
	const { data: data_snake } = await ajax.get(urlBuilder(id), null, { noCamelize: true })
	//const customFields = crop_snake.custom_fields
	const cropRecipe: CropRecipe = humps.camelizeKeys(data_snake)
	cropRecipe.customFields = data_snake.custom_fields
	return { data: cropRecipe }
}

/**
 * SAVE AND NEW
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-60435
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-60415
 */
const save = (id: number, cropRecipe: Partial<CropRecipe>): Promise<{ data: CropRecipe }> => {
	const crop_snake = humps.decamelizeKeys(cropRecipe)
	crop_snake.custom_fields = cropRecipe.customFields
	crop_snake.cost_1kg = cropRecipe.cost1kg
	delete crop_snake["cost1kg"]
	const recipe_snake = crop_snake.recipe
	delete crop_snake["recipe"]

	if (!!id) {
		return ajax.put(urlBuilder(id), { crop: crop_snake, recipe: recipe_snake }, { noDecamelize: true })
	} else {
		return ajax.post(`${urlBuilder()}`, { crop: crop_snake, recipe: recipe_snake }, { noDecamelize: true })
	}
}

/**
 * DELETE
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-60395
 */
const destroy = (id: number): Promise<void> => ajax.delete(urlBuilder(id))




// TO DO...


/**
 * ARCHIVE
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-28975
 */
const archive = (id: number): Promise<{ data: Crop }> => ajax.post(`${urlBuilder(id)}/archive`)

/**
 * BULK ARCHIVE
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-47215
 */
const bulkArchive = (ids: number[]): Promise<void> => ajax.post(`crops_recipes/bulk_archive`, { cropsIds: ids })

/**
 * RESTORE
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-28995
*/
const restore = (id: number): Promise<{ data: Crop }> => ajax.post(`${urlBuilder(id)}/restore`)


const cropsRecipesApi = {
	index,
	get,
	save,
	destroy,
	archive,
	bulkArchive,
	restore,
}
export default cropsRecipesApi